<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { ucFirst } from '@/lib/helper/string';
import { createModel } from '@/hooks/model';
import StringInput from '@/components/form/inputs/StringInput.vue';
import TextInput from '@/components/form/inputs/TextInput.vue';
import Button from '@/components/Button.vue';
import { ContactForm } from '@/forms/contact-form';
import { api } from '@/lib/api';
import { onMounted, ref } from 'vue';
import { dangerToast, successToast } from '@/lib/toast';

const [model, newModel, destroyModel] = createModel(ContactForm)

const route = useRoute()
const router = useRouter()
const param = route.params.title
const title = ucFirst(param.replace(/-/g, " "));
const buttonElt = ref<any>(null)
const recaptchaRef = ref<any>(null);

const send = () => {
    const data: any = model.value?.data

    const recaptchaResponse = grecaptcha.getResponse(recaptchaRef.value);

    if (!recaptchaResponse) {
        dangerToast({
            title: 'Please complete the reCAPTCHA challenge',
            closable: true,
        });
        return;
    }

    model.value?.validate()?.then((valid: boolean) => {
        if (valid) {

            buttonElt.value.start()
            api().track().post("/send-form", { 'data': data, 'subject': title }).then((response: any) => {
                successToast({
                    title: `Your form has submitted successfuly`,
                    closable: false,
                });
                buttonElt.value.stop()
            });

        }else{
            dangerToast({
            title: "You've missed one or more required parameter",
            closable: true,
        });
        }
    })


}


const direct = (name: string) => {
    router.push({ name, params: {} })
}

onMounted(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
        grecaptcha.ready(() => {
            recaptchaRef.value = grecaptcha.render('g-recaptcha', {
                sitekey: '6LfRdxIpAAAAAEny8jxR5hDLx9Dww4zyVEVGAnS8',
            });
        });
    };
})
newModel()
</script>
<style lang="scss"></style>
<template>
    <div class="form-body">
        <form @submit.prevent="send" v-if="model">
            <div class="form-head d-flex">
                <h2>Submit for a <b>{{ title }}</b></h2>
                <button @click="direct('contact')" class="btn btn-close"></button>
            </div>
            <div class="row">
                <div class="field col-12 col-md-6">
                    <StringInput noLabel :field="model?.firstName" :placeholder="model.firstName.label"></StringInput>
                </div>
                <div class="field col-12 col-md-6">
                    <StringInput noLabel :field="model?.lastName" :placeholder="model.lastName.label"></StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.phoneNumber" :placeholder="model.phoneNumber.label">
                    </StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.workEmail" :placeholder="model.workEmail.label"></StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.jobTitle" :placeholder="model.jobTitle.label"></StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.companyName" :placeholder="model.companyName.label">
                    </StringInput>
                </div>
                <div class="field col-12">
                    <TextInput noLabel :field="model?.description" :placeholder="model.description.label"></TextInput>
                </div>
            </div>
            <div class="feet">
                <Button ref="buttonElt" :text="'SUBMIT'" :loading-text="'Sending'"></Button>
                <div id="g-recaptcha" ref="recaptchaRef" class="g-recaptcha"></div>
            </div>
        </form>
    </div>
</template>